module.exports = __webpack_public_path__ + "img/cimb.27e4c778.png";